import { BaseTransformationVisitor } from './baseTransformation.visitor';
import { ColumnMappingBaseTransformPlainObject, ColumnMappingPlainObject } from '../plainObjects/columnMappingBase.plainObject';
import { ExpressionVisitor } from './expression.visitor';
import { SchemaUtil } from '../utils/schema.util';
import { MatchFunctionUtil } from '../utils/matchFunction.util';
import { Expression, ColumnOperand, FieldSelector } from '../models/expressionTypes';

/* eslint-disable @typescript-eslint/no-explicit-any */
export class ColumnMapVisitor extends BaseTransformationVisitor {
    public rowIndex: number = 0;
    protected get _transformation(): ColumnMappingBaseTransformPlainObject {
        return this.transformation as ColumnMappingBaseTransformPlainObject;
    }
    public visitAssignment(assignment: any): void {
        const expressionVisitor = new ExpressionVisitor(this._tokenStream);
        const expression: Expression = expressionVisitor.visit(assignment.expression());
        const column = expression.columnOperand;
        const originalColumn = column instanceof FieldSelector ? column.getFullPath() : column.getFullyQualifiedNameWhenBasicOperand();
        const arraySelector = column instanceof FieldSelector
            && (column.leftExpression.text && column.leftExpression.text.endsWith(']')) || (column.text && column.text.endsWith(']'));
        this._addColumnPlaceholder(SchemaUtil.getColumnName(assignment.columnIdentifier()), originalColumn, column instanceof FieldSelector, arraySelector);
    }

    public visitFunctionExpr(context: any): any {
        const patternMatching = ['each', 'every'];
        const key = context.basicFunction().basicName().getText();
        if (patternMatching.includes(key)) {
            MatchFunctionUtil.addExpressionBasedMappingColumnFromFunctionExpr(this._transformation, context, key === 'every', this.rowIndex++);
        } else {
            super.visitFunctionExpr(context);
        }
    }

    public visitColumnOperandRef(context: any): void {
        const expressionVisitor = new ExpressionVisitor(this._tokenStream);
        const columnOperand: ColumnOperand = expressionVisitor.visit(context.columnOperand());
        const columnName = columnOperand.getFullyQualifiedNameWhenBasicOperand();
        this._addColumnPlaceholder(columnName, columnName);
    }

    public visitMetaFunctionExpr(context: any): void {
        const patternMatching = ['each', 'every'];
        const key = context.metafunction().basicName().getText();
        if (patternMatching.includes(key)) {
            MatchFunctionUtil.addExpressionBasedMappingColumnFromMetaFunctionExpr(this._transformation, context, key === 'every', this.rowIndex++);
        } else {
            super.visitMetaFunctionExpr(context);
        }
    }

    protected _addColumnPlaceholder(aliasName: string, actualColumnName: string, isField?: boolean, isArraySelector?: boolean): void {
        const mapping = new ColumnMappingPlainObject();
        mapping.name = actualColumnName;
        mapping.alias = aliasName;
        mapping.isField = isField;
        mapping.isArraySelector = isArraySelector;
        mapping.rowIndex = this.rowIndex++;
        this._transformation.mappings.push(mapping);
    }
}
